<template>
     <div class="my-10">
        <div class="flex justify-center gap-20">
            <div class="flex flex-col gap-5">
                <h2 class="text-2xl font-bold">{{ $t('nav.complaints') }}</h2>
                <div class="flex flex-col gap-5">
                    <ComplaintCard v-for="report in reportList" :key="report.id" :detail="report"></ComplaintCard>
                </div>
                <div v-show="loading === true" class="flex justify-center mx-auto w-full" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
                <div v-show="reportList.length === 0 && loading === false">
                    <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { useAppStore } from '@/store'; // Import your Pinia store
import ComplaintCard from "../../components/ComplaintCard.vue";

export default {
    name: 'comments',
    components: {
        ComplaintCard
    },
    data(){
        return {
            loading: false,
            reportList: [],
        }
    },
    methods: {
        async getReports(){
            this.loading = true
            try{
                const response = await api.get('/comments/reports/');
                this.reportList = response.data.results
            }catch(e){
                console.log(e)
            }
            this.loading = false

        },
       
     
    },

    mounted(){
        const appStore = useAppStore();
        if (appStore.userData) {
            this.getReports()
        }
        else{
            const unwatch = this.$watch(
                () => appStore.userData,
                (newVal) => {
                    if (newVal) {
                        this.getReports();
                        unwatch(); // Unwatch once the data is fetched
                    }
                }
            );
        }
    }
}

</script>